import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment.prod';
import { Sliders } from '../models/sliders.model';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';
  
@Injectable({
    providedIn: 'root',
})
export class SlidersService extends BaseService<Sliders>  {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    API_URL = `${environment.apiUrl}/sliders`;
    API_URLGetAll = `${environment.apiUrl}/sliders`;
    constructor(@Inject(HttpClient) http, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http,  toastr, translationServices);
    }
  
 
}
